export const endpointCrmcontact = `${process.env.TIDE_COMMERCIAL_HOST}api/web/crmcontact`
export const endpointContact = `${process.env.TIDE_COMMERCIAL_HOST}api/web/contactform`
